import { motion } from "framer-motion";
import { ABOUT } from "@/data/content";
import { useReveal } from "@/hooks/useReveal";

const EASE = [0.2, 0.8, 0.2, 1];

export default function About() {
  const ref = useReveal();
  return (
    <section id="about" ref={ref} data-testid="about-section" className="relative py-28 sm:py-36 bg-[var(--bg-soft)] border-y border-[var(--line)]">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* portrait */}
        <div className="lg:col-span-5">
          <motion.div
            className="relative overflow-hidden rounded-2xl border border-[var(--line)]"
            style={{ aspectRatio: "4 / 5" }}
            initial={{ opacity: 0, y: 64, scale: 0.94 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1.7, ease: EASE }}
          >
            <motion.img
              src={ABOUT.portrait}
              alt={ABOUT.name}
              className="absolute inset-0 h-full w-full object-cover"
              style={{ filter: "grayscale(0.25) brightness(0.85)" }}
              initial={{ scale: 1.28 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 2.4, ease: EASE }}
            />
            <div className="absolute inset-0" style={{ background: "linear-gradient(180deg,transparent 55%,rgba(8,6,6,.7))" }} />
            <motion.div
              className="absolute bottom-5 left-5 right-5 flex items-end justify-between"
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6, ease: EASE, delay: 0.5 }}
            >
              <div>
                <div className="text-[var(--ink)] text-lg">{ABOUT.name}</div>
                <div className="label mt-1">{ABOUT.role}</div>
              </div>
            </motion.div>
          </motion.div>
        </div>

        {/* copy */}
        <div className="lg:col-span-7 reveal">
          <span className="label">About</span>
          <h2 className="display mt-5 text-[2.25rem] sm:text-[3.25rem] text-[var(--ink)] max-w-xl">
            Hi, I'm Jonas — <span className="serif-italic">nice to meet you.</span>
          </h2>
          <p className="mt-7 text-base sm:text-lg text-[var(--ink-dim)] leading-relaxed max-w-xl">
            {ABOUT.body}
          </p>
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-y-6 gap-x-4 border-t border-[var(--line)] pt-8">
            {ABOUT.facts.map((f) => (
              <div key={f.k}>
                <div className="label mb-2">{f.k}</div>
                <div className="text-sm text-[var(--ink)]">{f.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
